<template>
    <div>
      <el-drawer @reload="$reloadHandle"
                 :title="'退款审核'" size="30%"
                 :before-close="handleClose"
                 :visible.sync="drawer"
                 direction="rtl"
                 :modal-append-to-body="true"
                 custom-class="demo-drawer"
                 ref="drawer" >

        <div class="demo-drawer__content">
            <el-form :model="formData">
              退款单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;;margin-right: 5px;">{{ formData.orderBack }}</span>
            </el-form>
            <div style="display: flex;margin-top: 10px;   font-size: 12px;    color: rgba(86, 86, 86, 0.96);">
                <span>是否通过审核：</span>
                <el-radio-group v-model="formData.stat" @change="radioHandleChange">
                  <el-radio :label="1">通过</el-radio>
                  <el-radio :label="2">驳回</el-radio>
                </el-radio-group>
            </div>
          <el-form :model="formData">
            <el-form-item label="驳回原因" :rules="{required: true}">
              <el-input type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="formData.remark" :disabled="isRemark"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
            bottom: 5px; right: 5px;">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="refundCheck">确 定</el-button>
          </div>
        </div>
      </el-drawer>

    </div>
  </template>
  <script>

  import api from "@/api/projectApi";

  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['id','stat','remark','orderBack'],
    created() {
      console.log('askdfksdfk', this.id)
      this.formData.id = this.id
      this.formData.stat = this.stat
      this.formData.remark = this.remark
      this.formData.orderBack = this.orderBack
    },
    data() {
      return {
        formData: {
          remark: null,
          stat:null,
          id: null,
          type: null,
          orderBack:null
        },
        drawer: true,
        isRemark: true,
        // radioHandle: "",
      }
    },
    methods: {
      // 确定
      refundCheck() {
        this.$mask.open()
        this.$http({
          url: api.refundOrder.refundCheckUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$message.success('操作成功')
          // this.$message.success(res.data.msg);
          // this.$message.success('操作成功')
          this.visiable = false
          this.$emit('update:visiable', this.visiable)
          this.$emit('goBackIndex')
          this.cancelForm();
          this.$mask.close()
          this.flushed()// 需要刷新页面
        });
      },

      radioHandleChange(val) {
        this.radioHandle = val
        if (val == 1) { //通过
          this.formData.remark = "";
          this.isRemark = true
        }else  if (val == 2) { //驳回
          this.isRemark = false
        }
      },
      cancelForm() {
        this.visiable = false
        this.$emit('update:visiable', this.visiable)
      },
      handleClose() {
        this.cancelForm()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  </style>
